"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetAlignment = exports.CellAlignment = exports.AlignmentStrategy = exports.AlignmentMode = exports.ComparisonSpec = void 0;
const z = require("zod");
const value_comparison_1 = require("../Comparison/value-comparison");
class ComparisonSpec {
    constructor() {
        this.membershipContestable = true;
        this.autoResolveColumns = new Map();
    }
    rowKeyOf(row) {
        const normalize = (column, value, rowContext) => this.normalize(column, value, rowContext);
        if (this.alignment instanceof CellAlignment) {
            return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => normalize(column, value, rowContext));
        }
        return this.alignment instanceof SetAlignment ? this.alignment.identityOf(row, normalize) : JSON.stringify(row);
    }
    rowCellsFromKey(rowKey) {
        return this.alignment instanceof SetAlignment ? this.alignment.cellsOfIdentity(rowKey) : null;
    }
    normalize(_column, value, _row) {
        return (0, value_comparison_1.normalizeForComparison)(value);
    }
    admitsValue(_column, _value) {
        return true;
    }
    canonicalizeKeys(row) {
        return row;
    }
}
exports.ComparisonSpec = ComparisonSpec;
var AlignmentMode;
(function (AlignmentMode) {
    AlignmentMode["Cell"] = "cell";
    AlignmentMode["Set"] = "set";
})(AlignmentMode || (exports.AlignmentMode = AlignmentMode = {}));
class AlignmentStrategy {
}
exports.AlignmentStrategy = AlignmentStrategy;
class CellAlignment extends AlignmentStrategy {
    constructor(keyColumns, valueColumns) {
        super();
        this.keyColumns = keyColumns;
        this.valueColumns = valueColumns;
        this.mode = AlignmentMode.Cell;
    }
}
exports.CellAlignment = CellAlignment;
class SetAlignment extends AlignmentStrategy {
    constructor() {
        super(...arguments);
        this.mode = AlignmentMode.Set;
    }
    static { this.IDENTITY_SCHEMA = z.array(z.tuple([z.string(), z.string()])); }
    identityOf(row, normalize, columns) {
        const keys = (columns ? columns.map(String) : Object.keys(row)).sort();
        return JSON.stringify(keys.map((k) => [k, normalize(k, row[k], row)]));
    }
    cellsOfIdentity(identity) {
        let parsed;
        try {
            parsed = JSON.parse(identity);
        }
        catch {
            return null;
        }
        const pairs = SetAlignment.IDENTITY_SCHEMA.safeParse(parsed);
        return pairs.success ? Object.fromEntries(pairs.data) : null;
    }
}
exports.SetAlignment = SetAlignment;
//# sourceMappingURL=comparison-spec.js.map